import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["operator", "singleValue", "rangeValue", "singleInput", "rangeInput"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isBetween = this.operatorTarget.value === "between"

    this.singleValueTarget.classList.toggle("hidden", isBetween)
    this.rangeValueTarget.classList.toggle("hidden", !isBetween)

    this.singleInputTarget.disabled = isBetween
    this.rangeInputTargets.forEach(input => input.disabled = !isBetween)
  }
}
